<template>
  <div class="price-comparison bg-background-light p-6 md:px-8 md:py-16 text-left tracking-0.15px">
    <!-- Title -->
    <h6 class="text-lg md:text-2xl text-black-high-emphasis mb-2 md:mb-6">
      {{ content.title }}
    </h6>

    <!-- Description -->
    <div v-dompurify-html="content.description" class="richtext" data-testid="price-comparison-description"></div>

    <!-- Plus Provider card -->
    <ProviderCard
      :content="content.plusProviderCard"
      data-testid="plus-provider-card"
      class="my-4 md:my-6"/>

     <!-- Non Plus Provider card -->
    <ProviderCard
      :content="content.nonPlusProviderCard"
      data-testid="non-plus-provider-card" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ProviderCard from '@/components/molecules/ProviderCard/index.vue'
import { PriceComparison } from '@/model'

export default defineComponent({
  components: {
    ProviderCard
  },
  props: {
    content: {
      type: Object as () => PriceComparison,
      required: true,
      validator: (value: PriceComparison) => value instanceof PriceComparison
    }
  }
})
</script>
